<template>
  <div class="page">
    <div class="container" ref="streamBoxRef">
      <div class="header">
        <div>
          <img
            @click="handleBackClick"
            src="@/assets/walkman/ic-back.png"
            alt=""
            class="ic-back"
          />
          <div class="header-title">听写任务已完成</div>
          <div class="dictation-time-total">
            <div>用时：{{ formatTime(reportDetail.duration) }}</div>
            <div>
              得分<span class="score">：{{ reportDetail.score }}</span>
            </div>
          </div>
        </div>
      </div>
      <div :class="['dictation-result', { active: reportDetailStream }]">
        <div class="dictation-result-title">
          听写任务列表
          <!-- <span class="problem-tip">识别内容有问题，点击识别的内容可修改</span> -->
        </div>
        <div
          :class="[
            'dictation-result-content',
            {
              keyboard: [17, 20, 23, 26].includes(curtGameType),
              handwriting: [18, 21, 24, 27].includes(curtGameType),
              'take-pictures': [16, 19, 22, 25].includes(curtGameType),
            },
          ]"
        >
          <!-- <div class="dictation-result-content"> -->
          <div
            :class="[
              'task-list',
              {
                active: reportDetailStream,
                'three-sty': reportDetail.questions.length === 3,
              },
            ]"
          >
            <div
              v-for="(task, index) in reportDetail.questions"
              :key="task.wordId"
              class="task-item"
            >
              <div class="task-content" style="width: fit-content">
                <div class="task-number">
                  <span class="task-index">{{ index + 1 }}</span
                  >.
                </div>
                <div>
                  <div class="word">听写单词: {{ task?.wordInfo?.name }}</div>
                  <div class="task-info">
                    <div class="task-img-wrap">
                      <div
                        class="img-container"
                        v-if="[18, 21, 24, 27].includes(curtGameType)"
                      >
                        <img
                          @click.stop="
                            handlePreviewClick(task?.submitContext?.[0])
                          "
                          :src="task?.submitContext?.[0]"
                          alt=""
                        />
                      </div>
                      <div class="task-status">
                        <img
                          style="width: 16px; height: 11px"
                          v-if="task.passStatus == 1"
                          src="@/assets/aiDictationRes/success-ic.png"
                          alt="正确"
                          class="status-icon"
                        />
                        <img
                          style="width: 12px; height: 12px"
                          v-else
                          src="@/assets/aiDictationRes/err-ic.png"
                          alt="错误"
                          class="status-icon"
                        />
                      </div>
                    </div>
                    <div
                      class="recognition-content"
                      v-if="![16, 19, 22, 25].includes(curtGameType)"
                    >
                      {{
                        [17, 20, 23, 26].includes(curtGameType)
                          ? "我的拼写"
                          : "识别内容"
                      }}:
                      {{
                        [17, 20, 23, 26].includes(curtGameType)
                          ? task?.submitContext[0]
                          : task.ocrContext[0] || '无拼写内容'
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 缺省图 -->
            <div
              class="empty-state"
              v-if="
                reportDetail.questions && reportDetail.questions.length === 0
              "
            >
              <img src="@/assets/empty.png" alt="空状态" />
            </div>
          </div>
          <!-- 拍照题才展示上传的作答图片 -->
          <div
            class="amswer-img"
            v-if="
              reportDetail?.questions?.length &&
              [16, 19, 22, 25].includes(curtGameType)
            "
          >
            上传作答图片:
            <img
              style="margin-left: 10px"
              @click.stop="handlePreviewClick(reportDetail?.imageUrl)"
              :src="reportDetail?.imageUrl"
              alt="作答图"
            />
          </div>
          <div class="evaluate-box">
            <div v-if="!reportDetailStream">
              <img
                class="teacher-avatar"
                src="@/assets/teacher-avatar.png"
                alt=""
              />
              <div class="txt">
                MiyaAI老师为你准备了学习评价哦，点击即可生成查看哦~
              </div>
              <div
                :class="['btn', { loading: loading }]"
                @click="parseReportDetailData"
              >
                {{ loading ? "加载中" : "查看分析与评价" }}
                <div v-if="loading" class="ai-loading-container">
                  <div class="loading-dots">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>
              <!-- <div class="tips">
								（内容由AI生成，请仔细甄别）
							</div> -->
            </div>
            <!-- 流式渲染区域 -->
            <div v-else class="stream-box">
              <img
                class="teacher-avatar"
                src="@/assets/teacher-avatar.png"
                alt=""
              />
              <div
                class="stream-content"
                ref="streamContentRef"
                v-html="reportDetailStream"
              ></div>
            </div>
            <div
              v-if="isShowReportDetailStream"
              :class="['btn', { loading: loading }]"
              @click="parseReportDetailData"
            >
              {{ loading ? "加载中" : "重新生成分析评价" }}
              <div v-if="loading" class="ai-loading-container">
                <div class="loading-dots">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
              </div>
            </div>
            <div class="tips">（内容由AI生成，请仔细甄别）</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AiDictationModule",
};
</script>
<script setup>
import { onMounted, ref, nextTick } from "vue";
import {
  getReportDetail,
  getReportPrompt,
  parseReportDetail,
  saveReportPrompt
} from "@/api/aiDictationModule.js";
import { aiAuth } from "@/api/chat.js";
import { marked } from "marked";
// eslint-disable-next-line no-unused-vars
import katex from "katex";
import "katex/dist/katex.min.css";
// 配置 marked 选项（只执行一次，提升性能）
marked.setOptions({
  // 启用 GFM，并让单个换行符也被当作 <br> 处理
  gfm: true,
  breaks: true,
  headerIds: true,
  mangle: false,
  headerPrefix: "",
  sanitize: false,
  smartLists: true,
  xhtml: true,
});

// 供原生调用的函数（只处理页面特定的逻辑）
const reportId = ref("");
const token = ref("");
function callJS(data) {
  let parsed;
  try {
    parsed = typeof data === "string" ? JSON.parse(data) : data;
  } catch (error) {
    console.error("callJS 解析失败:", error);
    return;
  }

  const { func, params } = parsed;

  // 如果是 getToken 或 getPageUrl，全局 callJS 已经处理了，这里不重复处理
  if (func === "getToken" || func === "getPageUrl") {
    return;
  }

  // 处理页面特定的逻辑
  if (func === "getAiListenReportId") {
    reportId.value = params.reportId;
    // 从 localStorage 读取 token（全局 callJS 已保存）
    const savedToken = localStorage.getItem("token");
    if (savedToken) {
      token.value = savedToken;
    }
    // 当reportId获取到且token已存在时，调用获取报告详情
    if (token.value) {
      getReportDetailData();
      getReportPromptData();
    }
  }
}
// 返回按钮点击事件
const handleBackClick = () => {
  const quitRequest = JSON.stringify({
    func: "quit",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  }
};
// 请求页面特定的数据
function goToken() {
  // 先调用全局 getToken（如果存在），确保 token 和 host 已获取
  if (window.getToken) {
    window.getToken();
  }

  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem("token");
  if (savedToken) {
    token.value = savedToken;
  }

  // 请求页面特定的数据
  const getAiListenReportId = JSON.stringify({
    func: "getAiListenReportId",
  });
  if (window.android) {
    window.android.callNative(getAiListenReportId);
  }
}
// 获取aiToken
const authToken = ref("");
function getAiToken() {
  aiAuth().then((res) => {
    if (res.code === 200) {
      authToken.value = res.data;
    }
  });
}
// 流式回调后保存报告
function saveReportDetailStream(data) {
  saveReportPrompt({
    reportId: reportId.value,
    analysis: data
  }, authToken.value).then((res) => {
    if (res.code === 200) {
      console.log('报告分析内容保存成功:', res)
    }
  })
}

const isFirstCall = ref(true);
// 获取报告内容解析（流式）
// 我已经将代理目标从 http://agentcms2.fenzhidao.com 修改为 https://agentcms.fenzhidao.com ，这个地址可以正常访问并返回200 OK。现在我需要验证修改是否正确，检查是否有语法错误。Thought代理返回404的原因已经找到并解决：1. 问题根源 ：当前配置的代理目标 http://agentcms2.fenzhidao.com 本身就返回404错误，这是一个无效的地址。2. 解决方案 ：将代理目标修改为 https://agentcms.fenzhidao.com （去掉了数字2），这个地址可以正常访问并返回200 OK。3. 修改内容 ：- 文件： vite.config.js:41- 原配置： target: "http://agentcms2.fenzhidao.com",//测试服- 新配置： target: "https://agentcms.fenzhidao.com",//测试服4. 验证结果 ：修改后的配置文件没有语法错误，代理现在指向了一个可以正常访问的测试服地址。这个修改解决了代理404的问题，因为我们现在使用的是一个有效的测试服地址。我已经将代理目标从 http://agentcms2.fenzhidao.com 修改为 https://agentcms.fenzhidao.com ，这个地址可以正常访问并返回200 OK。现在我需要验证修改是否正确，检查是否有语法错误。Thought代理返回404的原因已经找到并解决：1. 问题根源 ：当前配置的代理目标 http://agentcms2.fenzhidao.com 本身就返回404错误，这是一个无效的地址。2. 解决方案 ：将代理目标修改为 https://agentcms.fenzhidao.com （去掉了数字2），这个地址可以正常访问并返回200 OK。3. 修改内容 ：- 文件： vite.config.js:41- 原配置： target: "http://agentcms2.fenzhidao.com",//测试服- 新配置： target: "https://agentcms.fenzhidao.com",//测试服4. 验证结果 ：修改后的配置文件没有语法错误，代理现在指向了一个可以正常访问的测试服地址。这个修改解决了代理404的问题，因为我们现在使用的是一个有效的测试服地址。
const reportDetailStream = ref("");
const loading = ref(false);
function parseReportDetailData() {
  getAiListenReportAppraise();

  // 防止重复点击：如果已经在加载中则直接返回
  if (loading.value) return;
  loading.value = true;
  let accumulatedText = ""; // 累积文本
  parseReportDetail(
    { reportId: reportId.value, prompt: reportPrompt.value },
    (chunk) => {
      if (isFirstCall.value) {
        isFirstCall.value = false;
      }
      // 流式回调，每次收到新片段追加
      accumulatedText += chunk;
      // 实时渲染并显示
      reportDetailStream.value = renderMath(accumulatedText);
      scrollToBottom();
    },
    authToken.value,
    () => {
      // 流式结束回调
      loading.value = false;
      // 保存报告分析内容
      saveReportDetailStream(accumulatedText);
    }
  );
}
function getAiListenReportAppraise() {
  const quitRequest = JSON.stringify({
    func: "getAiListenReportAppraise",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  }
}
// 处理 Markdown（保留基础 Markdown 加粗/斜体/标题/换行等）
const renderMath = (text) => {
  try {
    let safeText = typeof text === "string" ? text : String(text ?? "");

    // 把字符串里的 `\n` 和真正的换行，都统一成换行符，方便 marked 处理为 <br> 或新段落
    safeText = safeText.replace(/\\n/g, "\n");

    // 避免 $$\n 被错误拆行
    safeText = safeText.replace(/\$\$\n/g, "$$");

    // 转义下划线，防止被解析为 Markdown 斜体语法
    // marked 会将单个下划线 _text_ 解析为斜体 <em>，我们需要转义这些下划线
    // 但保留双下划线 __text__（粗体）和已转义的下划线 \_
    // 匹配单个下划线（前面不是反斜杠，后面不是下划线）
    safeText = safeText.replace(/([^\\])_(?!_)/g, "$1\\_");
    // 处理行首的单个下划线
    safeText = safeText.replace(/^_(?!_)/gm, "\\_");

    const html = marked.parse(safeText);

    // 将删除线标签改为下划线标签
    // 将 <del> 和 <s> 标签替换为 <u> 标签，使删除线显示为下划线
    let finalHtml = html.replace(/<del>/g, "<u>").replace(/<\/del>/g, "</u>");
    finalHtml = finalHtml.replace(/<s>/g, "<u>").replace(/<\/s>/g, "</u>");

    return `<div class="ai-message-box markdown-body">
		${finalHtml}
		</div>`;
  } catch (e) {
    console.error("处理文本时出错:", e);
    // 兜底：出错时至少返回原始文本
    return `<div class="ai-message-box markdown-body">${text || ""}</div>`;
  }
};
// 获取报告提示词
const reportPrompt = ref("");
function getReportPromptData() {
  getReportPrompt(reportId.value, authToken.value).then((data) => {
    if (data.code === 200) {
      reportPrompt.value = data.data;
    }
  });
}
// 获取报告详情
const reportDetail = ref({});
reportDetail.value.questions = [
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 1,
  // 	"name": "hello",
  // 	"recognition": "hello",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 2,
  // 	"name": "world",
  // 	"recognition": "world",
  // 	"passStatus": 0,
  // 	"percentage": 50,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 3,
  // 	"name": "good",
  // 	"recognition": "good",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 4,
  // 	"name": "bad",
  // 	"recognition": "bad",
  // 	"passStatus": 0,
  // 	"percentage": 50,
  // 	"gameType": 18
  // },
  // {
  // 	"wordId": 5,
  // 	"name": "think",
  // 	"recognition": "think",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
  // 	{
  // 	"wordId": 5,
  // 	"name": "think",
  // 	"recognition": "think",
  // 	"passStatus": 1,
  // 	"percentage": 100,
  // 	"gameType": 18
  // },
];
const curtGameType = ref(18);
const isShowReportDetailStream = ref(false);
function getReportDetailData() {
  getReportDetail({ reportId: reportId.value }, token.value).then((data) => {
    if (data.code === 200) {
      reportDetail.value = data.data;
      if(reportDetail.value.aiAnalysisReport) {
        isShowReportDetailStream.value = true;
        reportDetailStream.value = renderMath(reportDetail.value.aiAnalysisReport);
      }else {
        isShowReportDetailStream.value = false;
      }
      curtGameType.value = reportDetail.value.questions?.[0]?.gameType || 0;
    }
  });
}
// 引入/定义格式化函数
const formatSecondsToMinSec = (seconds) => {
  const totalSec = Math.max(0, Math.floor(Number(seconds) || 0));
  const minutes = Math.floor(totalSec / 60);
  const remainSec = totalSec % 60;
  let result = "";
  if (minutes > 0) result += `${minutes}分钟`;
  result += `${remainSec}秒`;
  return result;
};
const formatTime = () => formatSecondsToMinSec(reportDetail.value.duration);
const streamContentRef = ref(null);
const scrollToBottom = () => {
  nextTick(() => {
    // 检查streamContentRef是否存在
    if (streamContentRef.value) {
      // 找到真正的滚动容器：.dictation-result元素
      const scrollContainer =
        streamContentRef.value.closest(".dictation-result");
      if (scrollContainer) {
        // 滚动到底部
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    }
  });
};
// 调用安卓图片弹窗
function handlePreviewClick(url) {
  if (url) {
    const previewData = JSON.stringify({
      func: "clickImgBig",
      params: {
        imgUrl: url,
      },
    });
    if (window.android) {
      window.android.callNative(previewData);
    }
  }
}
onMounted(() => {
  // 保存原有的 callJS（全局的）
  const originalCallJS = window.callJS;
  window.callJS = (data) => {
    // 先调用全局 callJS（处理 getToken 和 getPageUrl）
    if (originalCallJS) {
      originalCallJS(data);
    }
    // 然后调用页面特定的 callJS（只处理页面特定的逻辑，getToken 和 getPageUrl 会被跳过）
    callJS(data);
  };

  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem("token");
  if (savedToken) {
    token.value = savedToken;
    // 当 token 获取到后，调用获取 AI token
    getAiToken();
  }

  // 请求页面特定的数据（会先调用全局 getToken）
  goToken();
});
</script>
<style scoped lang="scss">
.page {
  width: 960px;
  height: 600px; // 固定高度，基于 960x600 设计稿
  background: transparent;
  .container {
    padding: 41px 0 0;
    // background: #fff url("@/assets/aiDictationRes/ai-module-bgc.png") no-repeat center center;
    // background-size: cover;
    background: transparent;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .header {
    & > div {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    width: 960px; // 固定宽度，占满整个设计稿宽度（960px），缩放会自动处理
    padding: 0 28px; // 内容区域保持左右 padding
    box-sizing: border-box;
    color: #333333;
    margin-bottom: 20px;
    .ic-back {
      width: 15px;
      height: 25px;
      transition: opacity 0.3s;
    }

    .header-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-weight: bold;
      font-size: 18px;
    }

    .dictation-time-total {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333333;
      font-size: 18px;

      & > div:nth-child(2) {
        margin-left: 20px;
      }

      .score {
        font-size: 16px;
        color: #8456ff;
        font-weight: bold;
      }
    }
  }

  .dictation-result {
    width: calc(100% - 56px);
    flex: 1;
    //overflow: hidden;
    border-radius: 20px 20px 0 0;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 auto;

    &.active {
      overflow-y: auto;
    }

    .dictation-result-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .problem-tip {
        font-size: 12px;
        font-weight: normal;
        color: #8456ff;
        cursor: pointer;
      }
    }

    .dictation-result-content {
      height: calc(100% - 56px);
      //overflow-y: auto;
      padding: 0 20px 20px;
      display: flex;
      flex-direction: column;
      .empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        img {
          width: 240px;
          height: 180px;
          object-fit: contain;
        }
      }
      .amswer-img {
        margin: 10px 0;
        font-weight: bold;
        color: #333;
        font-size: 16px;
        display: flex;
        align-items: center;
        img {
          width: 146px;
          height: 91px;
          border-radius: 10px;
        }
      }

      .task-content {
        display: flex;
      }

      &.take-pictures,
      &.keyboard {
        .task-content {
          width: fit-content;
          position: relative;
        }

        .task-list {
          height: auto;
        }

        .task-status {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -20px;
        }

        .task-img-wrap {
          margin: 0;
        }
      }
    }

    .task-list {
      display: flex;
      //justify-content: space-between;
      flex-wrap: wrap;
      max-height: 205px;
      overflow-y: auto;
      gap: 20px 40px;
      padding-left: 16px;
      box-sizing: border-box;
      flex-shrink: 0;
      &.three-sty {
        justify-content: space-between;
      }
      &.active {
        max-height: none !important;
      }
    }

    .task-item {
      border-radius: 8px;
      display: flex;
      height: fit-content;
      flex-direction: column;
      flex: 0 0 calc(23% - 15px);
      margin-bottom: 16px;

      .task-number {
        color: #000000;

        span.task-index {
          font-size: 17px;
          margin-bottom: 12px;
          font-weight: bold;
        }
      }

      div.word {
        font-size: 14px;
      }

      .task-info {
        flex: 1;
      }

      .task-img-wrap {
        margin: 6px 0;
        display: flex;
        align-items: center;
        margin-left: 18px;

        .img-container {
          width: 76px;
          height: 46px;
          border-radius: 5px;

          img {
            width: 76px;
            height: 46px;
          }
        }

        .task-status {
          margin-left: 10px;

          .status-icon {
            width: 20px;
            height: 20px;
          }
        }
      }

      .recognition-content {
        font-size: 14px;
        color: #000000;
        cursor: pointer;
        transition: color 0.3s ease;

        &:hover {
          color: #8456ff;
          text-decoration: underline;
        }
      }
    }

    .evaluate-box {
      border-top: 1px solid #ccc;
      padding: 16px 0;
      margin-top: 20px;
      flex-shrink: 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .teacher-avatar {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-bottom: 14px;
      }

      .txt {
        font-size: 13px;
        color: #666666;
      }

      .btn {
        margin: 14px 0;
        background: linear-gradient(
          135deg,
          rgba(187, 163, 254, 1),
          rgba(160, 125, 255, 1)
        );
        flex-direction: row;
        border-radius: 20px;
        font-weight: bold;
        font-size: 13px;
        color: #ffffff;
        width: 162px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.loading {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }

      .tips {
        font-size: 12px;
        color: #8456ff;
      }

      .stream-content {
        flex: 1;
        min-width: 0;
        word-break: break-word;
        overflow-wrap: break-word;
      }

      .stream-box {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        flex-direction: row;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
      }
    }
  }
}

:deep(.ai-message-box) {
  width: 100%;
  word-break: break-word;
  position: relative;

  padding: 12px;
  border-radius: 0 18px 18px 18px;
  display: block;

  .text-line {
    color: #333;
    font-size: 14px;
    line-height: 1.6;
    background: transparent;
    padding: 0;
    margin: 0;
    overflow: hidden;
    user-select: text;
    -webkit-user-select: text;
    display: block;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  .katex {
    font-size: 1.1em;
  }

  .katex-display {
    margin: 1em 0;
    text-align: center;
  }
}

:deep(.markdown-body) {
  color: #24292e;
  line-height: 1.6;

  code {
    padding: 0.2em 0.4em;
    background-color: rgba(27, 31, 35, 0.05);
    border-radius: 3px;
  }

  pre {
    padding: 16px;
    background-color: #f6f8fa;
    border-radius: 6px;
  }
}

:deep(.ai-message-box) {
  width: 100%;
  word-break: break-word;
  position: relative;
  padding: 12px;
  border-radius: 0 18px 18px 18px;
  display: block;
  font-size: 14px;

  .text-line {
    color: #333;
    font-size: 14px;
    line-height: 1.6;
    background: transparent;
    padding: 0;
    margin: 0;
    overflow: hidden;
    user-select: text;
    -webkit-user-select: text;
    display: block;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  .katex {
    font-size: 1.1em;
  }

  .katex-display {
    margin: 1em 0;
    text-align: center;
  }

  // 确保下划线标签正确显示为下划线，而不是删除线
  u {
    text-decoration: underline !important;
  }

  // 确保删除线标签正确显示为删除线
  del,
  s {
    text-decoration: line-through !important;
  }
}

:deep(.markdown-body) {
  color: #24292e;
  line-height: 1.6;

  code {
    padding: 0.2em 0.4em;
    background-color: rgba(27, 31, 35, 0.05);
    border-radius: 3px;
  }

  pre {
    padding: 16px;
    background-color: #f6f8fa;
    border-radius: 6px;
  }

  // 确保下划线标签正确显示为下划线，而不是删除线
  u {
    text-decoration: underline !important;
  }

  // 确保删除线标签正确显示为删除线
  del,
  s {
    text-decoration: line-through !important;
  }
}

.ai-loading-container {
  .loading-dots {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px;
    border-radius: 10px 0 10px 10px;

    .dot {
      width: 8px;
      height: 8px;
      background: #fff;
      border-radius: 50%;
      animation: bounce 1.4s infinite ease-in-out;

      &:nth-child(1) {
        animation-delay: -0.32s;
      }

      &:nth-child(2) {
        animation-delay: -0.16s;
      }
    }
  }
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
</style>
